/** Created by azhou on 2018/8/17.*/
<template>
  <!--标题部分-->
  <div class="d-center-start mb-2 pb-2">
    <!--<span class="title-logo"></span>
    <span class="title-logo ml-1" style="opacity: .6;"></span>
    <span class="title-logo ml-1" style="opacity: .3;"></span>-->
    <span class="font-weight-bold ml-2 h5"><slot></slot><label v-if="showStore"><i class="el-icon-right"></i>{{$route.query.GST}}</label></span>
    <span class="text-link ml-auto" @click="$router.back()" v-if="showBack">返回上一页</span>
    <slot name="right"></slot>
  </div>
</template>

<script>
  export default {
    name: 'PublicTitle',
    props:{
      showBack:{
        type:Boolean,
        default:false
      }
    },
    computed: {
      showStore () {
        return this.$route.query.GST
      }
    }
  }
</script>
<style lang="scss" scoped>
  .title-logo {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: rgb(147, 222, 251);
  }
  .border-dark {
    border-bottom: 1px solid #919191;
  }
</style>
